import { useQuery } from '@tanstack/react-query';
import { ClaimStatus } from '../../../../types/claims/claim.dto';
import { getClaims } from '../../../../api';
import { getData } from '../../../../utils/functional/fp';

type UseIsActiveClaimOnAccountProps = { accountId: string };

const useIsActiveClaimOnAccount = (
  props: UseIsActiveClaimOnAccountProps
): UseIsActiveClaimOnAccountReturn => {
  const activeClaimsForAccountQuery = useQuery({
    queryKey: [
      'claims',
      'active',
      { active: true, accountId: props.accountId },
    ],
    queryFn: () =>
      getClaims({
        params: {
          search: props.accountId,
          filter: { status: { in: ClaimStatus.OPEN } },
          size: 1,
        },
      }).then(getData),
  });

  if (activeClaimsForAccountQuery.data == null) {
    return {
      isLoading: true,
      isActiveClaim: undefined,
    };
  }

  return {
    isLoading: false,
    isActiveClaim: activeClaimsForAccountQuery.data.data.length !== 0,
  };
};

export default useIsActiveClaimOnAccount;

type UseIsActiveClaimOnAccountReturn =
  | {
      isLoading: false;
      isActiveClaim: boolean;
    }
  | {
      isLoading: true;
      isActiveClaim: undefined;
    };
